import React, {useCallback, useEffect, useState} from "react";


import { useSharedListStyles } from "../../../shared/useSharedListStyles";


import { connect, useSelector } from "react-redux";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import WuDataService from "../../../services/WuDataService";
import WuDbDataList from "./WuDbDataList";
import {List, ListItem} from "@mui/material";
import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";

// WU-Import: welcher Service-Aufruf zu welchem gewaehlten Objekttyp gehoert.
// addNew (mit rowData.guid) und importAll (mit '') nutzen dieselbe Zuordnung.
const WU_IMPORT_SERVICE_BY_TYPE = {
    parcel: WuDataService.importWuParcelData,
    buildingentrance: WuDataService.importWuLocationData,
    territorialdivision: WuDataService.importWuTerritorialdivisionData,
    economicunit: WuDataService.importWuEconomicunitData,
    rentalunit: WuDataService.importWuRentalunitAppartmentData,
    commercialunit: WuDataService.importWuRentalunitCommercialData,
    parkingspace: WuDataService.importWuRentalunitParkingData,
    rentalunitnotlet: WuDataService.importWuRentalunitNotletData,
    site: WuDataService.importWuSiteData,
    structure: WuDataService.importWuStructureData,
    building: WuDataService.importWuBuildingData,
    storey: WuDataService.importWuStoreyData,
    room: WuDataService.importWuRoomData,
};

// Objekttyp-Auswahl -> welcher Objekttyp/Typ geladen wird und wie die Tabelle betitelt wird.
// Hinweis: 'parcel' kam im urspruenglichen switch doppelt vor (zweiter Fall mit Titel
// 'Flurstück' war durch den switch-Fallthrough bereits unerreichbar) - hier bewusst nur
// der tatsaechlich wirksame erste Fall ('Flurstücke') uebernommen.
const WU_OBJECT_TYPE_CONFIG = {
    site: { objecttype: 'realestateobject', type: 'site', title: 'Liegenschaften' },
    structure: { objecttype: 'realestateobject', type: 'structure', title: 'Bauwerke' },
    building: { objecttype: 'realestateobject', type: 'building', title: 'Gebäude' },
    room: { objecttype: 'realestateobject', type: 'room', title: 'Räume' },
    storey: { objecttype: 'realestateobject', type: 'storey', title: 'Etagen' },
    economicunit: { objecttype: 'administrativeobject', type: 'economicunit', title: 'Wirtschafteinheiten' },
    rentalunit: { objecttype: 'administrativeobject', type: 'rentalunit', title: 'Mieteinheiten' },
    commercialunit: { objecttype: 'administrativeobject', type: 'commercialunit', title: 'Gewerbeeinheiten' },
    parkingspace: { objecttype: 'administrativeobject', type: 'parkingspace', title: 'Stellplatzanlagen' },
    location: { objecttype: 'administrativeobject', type: 'buildingentrance', title: 'Hauseingänge' },
    buildingentrance: { objecttype: 'administrativeobject', type: 'buildingentrance', title: 'Hauseingänge' },
    parcel: { objecttype: 'administrativeobject', type: 'parcel', title: 'Flurstücke' },
    territorialdivision: { objecttype: 'administrativeobject', type: 'territorialdivision', title: 'Gebietsgliederungen' },
    rentalunitnotlet: { objecttype: 'administrativeobject', type: 'rentalunitnotlet', title: 'unvermietet' },
};
const DEFAULT_WU_OBJECT_TYPE_CONFIG = { objecttype: 'administrativeobject', type: 'economicunit', title: 'Wirtschaftseinheiten' };



function WuDbData({theRealm}) {
    // const [treeItemsState] = useContext(TreeItemsStateContext);
    const token = useSelector((state) => state.keycloakToken);
    const [dataList , setDataList] = useState([]);

    const classes = useSharedListStyles();
    // console.dir(bimProf);

    useEffect(() => {
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, [])

    // const kctoken = sessionStorage.getItem('kctoken');
    // setToken(kctoken);


    const GetWuData = useCallback(async (type) => {
        try {
            await trackPromise(
               /* WuDataService.getWuDatenList(token, theRealm)
                    .then((res) => {
                        setDataList(res.data);
                    })*/
                WuDataService.getWuObjectList(token, theRealm, type)
                .then((res) => {
                    setDataList(res.data);
                })
            )
            /*
            WuDataService.getWuList(token, theRealm)
                .then((res) => {
                    console.log(res.data);
                    if(res.data) {
                        const tempArray = res.data;
                        tempArray.forEach(async (item) => {
                            if(item.Kürzel === 'Bille') {
                                console.log(item.ID)
                                await trackPromise(
                                WuDataService.getWuVeList(token, theRealm, item.ID)
                                    .then(result => {
                                        console.log(result.data)
                                        setDataList(result.data);
                                    })
                                )
                            }
                        })

                    }
                })
            */
        } catch (e) {
            console.log(e);
        }
    }, []);


    const importSelectedWuData = async (guid) => {
        try {
            const importFn = WU_IMPORT_SERVICE_BY_TYPE[selected];
            if (importFn) {
                await trackPromise(
                    importFn(token, theRealm, guid)
                        .then((res) => {
                            console.log(res.data);
                        })
                );
            }
        } catch (e) {
            console.log(e);
        }
    }

    const addNew = async (rowData) => {
        console.log(rowData);
        await importSelectedWuData(rowData.guid);
    }

    const addStorey = async (rowData) => {
        try {
            console.log(rowData)

            await trackPromise(
                WuDataService.importWuStoreyData(token, theRealm, rowData.wuid, rowData.veid)
                    .then((res) => {
                        console.log(res.data);
                        if(res.data) {

                            // setBimetaProfiles(res.data);
                        }

                    })
            )

        } catch (e) {
            console.log(e);
        }
    }

    const addRoom = async (rowData) => {
        try {
            console.log(rowData)

            await trackPromise(
                WuDataService.importWuRoomData(token, theRealm, rowData.wuid, rowData.veid)
                    .then((res) => {
                        console.log(res.data);
                        if(res.data) {

                            // setBimetaProfiles(res.data);
                        }

                    })
            )

        } catch (e) {
            console.log(e);
        }
    }

    const importAll = () => importSelectedWuData('');


    const options = [
        {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
        {value: 'territorialdivision', text: 'Gebietsgliederung'},
        {value: 'site', text: 'Liegenschaft'},
        {value: 'economicunit', text: 'Wirtschaftseinheit'},
        {value: 'parcel', text: 'Flurstück'},
        {value: 'structure', text: 'Bauwerk'},
        {value: 'building', text: 'Gebäude'},
        {value: 'storey', text: 'Geschoß'},
        {value: 'buildingentrance', text: 'Hauseingang'},
        {value: 'rentalunit', text: 'Mieteinheit'},
        {value: 'commercialunit', text: 'Gewerbeeinheit'},
        {value: 'room', text: 'Raum'},
        {value: 'parkingspace', text: 'Stellplatz'},
        {value: 'rentalunitnotlet', text: 'unvermietet'},
    ];

    const [selected, setSelected] = useState(options[0].value);
    const [title, setTitle] = useState('Wirtschaftseinheiten');
    const [fieldType, setFieldType] = useState('administrativeobjectType');
    const [bauteilAction, setBauteilAction] = useState('');

    let hideDeactivatedColumn = true


    const handleChange = async(event) => {
        await putChangesInMotion(event.target.value);
    }

    const putChangesInMotion = (val) => {
        console.log(val);
        setSelected(val);
        const config = WU_OBJECT_TYPE_CONFIG[val] || DEFAULT_WU_OBJECT_TYPE_CONFIG;
        setTitle(config.title);
        setFieldType(config.objecttype === 'realestateobject' ? 'realestateobjectType' : 'administrativeobjectType');

        return GetWuData(config.type);
    };


    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <List style={{backgroundColor: "#FFFFFF"}}>
                    <ListItem>
                        <ObjecttypeSelectlist
                            options={options}
                            selected={selected}
                            handleChange={handleChange}
                        />
                    </ListItem>
                </List>
                <div className={classes.btListe}>
                    <WuDbDataList
                        dataList={dataList}
                        addNew={addNew}
                        addStorey={addStorey}
                        addRoom={addRoom}
                        importAll={importAll}
                        title={title}
                    />
                </div>

            </div>
        </div>
    );
};

function mapState({theRealm}) {
    return {
        theRealm: theRealm
    }
}

export default connect(
    mapState,
    null
)(WuDbData);